import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/ui/card'
import { Flex } from '@/components/ui/flex'
import { media } from '@/theme/common'

export const Card = styled(DefaultCard)(({ theme }) => ({
  flexShrink: 0,
  gap: theme.space['16'],
  height: 'auto',
  [media.down('sm')]: {
    boxShadow: 'none',
    gap: theme.space['8'],
    padding: theme.space['12'],
  },
}))

export const AnalyticsHeader = styled(Flex)`
  ${media.down('sm')} {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space['8']};
  }
`

export const DatePickerWrapper = styled.div(({ theme }) => ({
  flexShrink: 0,
  width: theme.space['240'],

  [media.down('sm')]: {
    width: '100%',
  },
}))

export const MetricsGroup = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray300}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['20'],
  padding: theme.space['20'],

  [media.down('sm')]: {
    gap: theme.space['12'],
    padding: theme.space['12'],
  },
}))

export const MetricsRow = styled.div(({ theme }) => ({
  '&:not(:first-of-type)': {
    borderTop: `${theme.border.size['1']} solid ${theme.colors.gray300}`,
    paddingTop: theme.space['16'],
  },

  '&:not(:last-of-type)': {
    paddingBottom: theme.space['16'],
  },

  columnGap: theme.space['32'],
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: theme.space['16'],

  [media.down('sm')]: {
    '&:not(:first-of-type)': {
      paddingTop: theme.space['8'],
    },

    '&:not(:last-of-type)': {
      paddingBottom: theme.space['8'],
    },

    rowGap: theme.space['8'],
  },
}))

// Note: pads the shimmer bar out to the "heading-huge" Typography's own line-height
// (3.2rem = 2.4rem skeleton + 0.4rem top/bottom) so the card doesn't jump in height
// when the skeleton is swapped for the real value once loaded.
export const ValueSkeletonWrapper = styled.div(({ theme }) => ({
  padding: `${theme.space['4']} 0`,
}))

export const MetricCard = styled.div(({ theme }) => ({
  '&:not(:first-of-type)::before': {
    backgroundColor: theme.colors.gray300,
    bottom: 0,
    content: '""',
    left: `calc(-1 * ${theme.space['32']} / 2)`,
    position: 'absolute',
    top: 0,
    width: theme.border.size['1'],
  },

  display: 'flex',
  flex: '1 1 14rem',
  flexDirection: 'column',
  gap: theme.space['8'],
  minWidth: '14rem',
  position: 'relative',

  [media.down('sm')]: {
    '&:not(:first-of-type)::before': {
      display: 'none',
    },
    flexBasis: '100%',
  },
}))
